import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUserAvatarSrc, isGroup } from '../../../User/helpers';
import AvatarImage from '../../AvatarImage';
const BasicUserAvatar = ({ user, size: height, className, 'aria-hidden': ariaHidden, enableLazyLoad = true })=>{
    var _user;
    const { t } = useTranslation();
    var _getUserAvatarSrc;
    const imgSrc = (_getUserAvatarSrc = getUserAvatarSrc(user)) !== null && _getUserAvatarSrc !== void 0 ? _getUserAvatarSrc : undefined;
    const width = user && isGroup(user) ? 2 * height : height;
    return /*#__PURE__*/ React.createElement(AvatarImage, {
        width: width,
        height: height,
        src: imgSrc,
        className: className,
        alt: ariaHidden === 'true' ? '' : t('avatar.alt', {
            username: ((_user = user) === null || _user === void 0 ? void 0 : _user.username) || t('avatar.unknownUser')
        }),
        "aria-hidden": ariaHidden,
        enableLazyLoad: enableLazyLoad
    });
};
BasicUserAvatar.displayName = 'BasicUserAvatar';
export default BasicUserAvatar;
